import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_PLAY_CIRCLE: GlameraIconDefinition = {
  name: 'play-circle',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-play-circle-ring" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
    <path class="glm-play-circle-triangle" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-play-circle-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './play-circle.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PlayCircleIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_PLAY_CIRCLE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
